module.exports = __webpack_public_path__ + "img/pethouse27.8c4fc74c.jpg";